var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"hide-delete":"","hide-edit":"","hide-select":"","api-debounce-time":500,"headers":"utility_code,imot_N,imot_type,address,location","filter":_vm.filter,"params":{deviceNo: _vm.deviceNo},"item-class":()=>'cursor-pointer'},on:{"click:row":_vm.clickRow}})
}
var staticRenderFns = []

export { render, staticRenderFns }